//Ensures only the fields for the current locale are used.
const getTrackRestrictedAttributes = (locale: string): string[] => {
	let countryCode = locale.substring(3)
	const attributes = [
		'MusicalStyles',
		'Moods',
		'Title',
		'Instrumentations',
		'ProductionGenres',
		'Toolkit',
		'TempoName',
		'Description',
		'Album.Name',
		'Composers.FirstName',
		'Composers.LastName',
		'OriginalComposer',
		'MixType',
		'Eras',
		'Keywords',
		'AlbumTrackAliases',
		'TrackFilenames',
		'Isrc',
	]

	if (countryCode != 'GB' && countryCode != 'US' && countryCode != 'AU') {
		countryCode = countryCode[0] + countryCode[1].toLowerCase()
		attributes.push(
			`MusicalStyles_${countryCode}`,
			`Moods_${countryCode}`,
			`Instrumentations_${countryCode}`,
			`ProductionGenres_${countryCode}`,
			`Toolkit_${countryCode}`,
			`TempoName_${countryCode}`
		)
	}
	return attributes
}

function getLyricsRestrictedAttributes(): readonly string[] {
	return ['Lyrics']
}

export { getLyricsRestrictedAttributes, getTrackRestrictedAttributes }
